import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardLinkIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22.37 2.92L21.08 1.63C18.91 -0.539998 15.39 -0.539998 13.22 1.63L9.6 5.25C9.21 5.64 9.21 6.27 9.6 6.66C9.99 7.05 10.62 7.05 11.01 6.66L14.63 3.04C16.02 1.65 18.27 1.65 19.66 3.04L20.95 4.33C21.62 5 21.99 5.9 21.99 6.85C21.99 7.8 21.62 8.69 20.95 9.36L17.08 13.23C15.74 14.57 13.39 14.57 12.05 13.23L10.76 11.94C10.37 11.55 9.74 11.55 9.35 11.94C8.96 12.33 8.96 12.96 9.35 13.35L10.64 14.64C11.69 15.69 13.08 16.27 14.57 16.27C16.06 16.27 17.45 15.69 18.5 14.64L22.37 10.77C23.42 9.72 24 8.33 24 6.84C24 5.35 23.42 3.96 22.37 2.91V2.92Z"
        fill={color}
      />
      <path
        d="M12.98 17.34L9.35999 20.96C8.01999 22.3 5.66999 22.3 4.32999 20.96L3.03999 19.67C1.64999 18.28 1.64999 16.03 3.03999 14.64L6.90999 10.77C8.29999 9.38001 10.55 9.38001 11.94 10.77L13.23 12.06C13.62 12.45 14.25 12.45 14.64 12.06C15.03 11.67 15.03 11.04 14.64 10.65L13.35 9.36001C11.18 7.19001 7.65999 7.19001 5.48999 9.36001L1.61999 13.23C-0.550007 15.4 -0.550007 18.92 1.61999 21.09L2.90999 22.38C3.95999 23.43 5.34999 24.01 6.83999 24.01C8.32999 24.01 9.71999 23.43 10.77 22.38L14.39 18.76C14.78 18.37 14.78 17.74 14.39 17.35C14 16.96 13.37 16.96 12.98 17.35V17.34Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardLinkIcon.displayName = 'BoardLinkIcon';
